import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ListExchangesComponent} from './components/list-exchanges/list-exchanges.component';
import {TableModule} from 'primeng/table';
import {RouterModule} from '@angular/router';
import {DadConfigCrudComponent} from './components/dad-config-crud/dad-config-crud.component';
import {DropdownModule} from 'primeng/dropdown';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CalendarModule} from 'primeng/calendar';
import {MultiSelectModule} from 'primeng/multiselect';
import {TooltipModule} from 'primeng/tooltip';
import {PanelModule} from 'primeng/panel';
import {CheckboxModule} from 'primeng/checkbox';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {TabViewModule} from 'primeng/tabview';
import {ListReportersComponent} from './components/list-reporters-component/list-reporters.component';
import {
  CsvService,
  DadConfigService,
  DadProductService,
  ExchangeService,
  MdMarketService,
  ReporterService
} from './services/services';
import {DadProductCrudComponent} from './components/dad-product-crud/dad-product-crud.component';
import {AutoReportPipe} from './pipes/auto-report/auto-report.pipe';
import {DialogService, DynamicDialogModule} from 'primeng/dynamicdialog';
import {DadFormComponent} from './components/dad-forms/dad-form/dad-form.component';
import {EurexReportComponent} from './components/dad-forms/eurex-report/eurex-report.component';
import {IceReportComponent} from './components/dad-forms/ice-report/ice-report.component';
import {ConfirmationSectionComponent} from './components/dad-forms/confirmation-section/confirmation-section.component';
import {AppSharedModule} from '../appSharedModule/app-shared.module';
import {DadProductPriceCrudComponent} from './components/dad-product-price-crud/dad-product-price-crud.component';
import {CsvReportComponent} from './components/dad-admin-page/csv-report/csv-report.component';
import {DadStatusComponent} from './components/dad-admin-page/dad-status/dad-status.component';
import {ConfirmationService} from 'primeng/api';
import {DadAdminComponent} from './components/dad-admin-page/dad-admin/dad-admin.component';
import {DadFormsListComponent} from './components/dad-admin-page/dad-forms-list/dad-forms-list.component';
import {ComparisonReportComponent} from './components/dad-admin-page/comparison-report/comparison-report.component';
import {RebillingComponent} from './components/dad-admin-page/rebilling/rebilling.component';
import {FloatLabelModule} from 'primeng/floatlabel';

import {
  ThresholdExplanationComponent
} from './components/dad-forms/threshold-explanation/threshold-explanation.component';
import {InputTextModule} from 'primeng/inputtext';
import {LseReportComponent} from './components/dad-forms/lse-report/lse-report.component';
import {TurqReportComponent} from './components/dad-forms/turq-report/turq-report.component';
import {MessageModule} from 'primeng/message';

@NgModule({
  declarations: [
    ListExchangesComponent,
    DadConfigCrudComponent,
    ListReportersComponent,
    DadProductCrudComponent,
    DadAdminComponent,
    DadFormsListComponent,
    AutoReportPipe,
    DadFormComponent,
    EurexReportComponent,
    IceReportComponent,
    LseReportComponent,
    TurqReportComponent,
    ConfirmationSectionComponent,
    DadProductPriceCrudComponent,
    ThresholdExplanationComponent,
    CsvReportComponent,
    ComparisonReportComponent,
    RebillingComponent,
    DadStatusComponent,
  ],
    imports: [
        CommonModule,
        TableModule,
        RouterModule,
        DropdownModule,
        FormsModule,
        ReactiveFormsModule,
        CalendarModule,
        MultiSelectModule,
        TooltipModule,
        DynamicDialogModule,
        PanelModule,
        CheckboxModule,
        AppSharedModule,
        ConfirmDialogModule,
        TabViewModule,
        FloatLabelModule,
        InputTextModule,
        MessageModule,
    ],
  providers: [
    DadConfigService,
    ReporterService,
    ExchangeService,
    MdMarketService,
    DialogService,
    DadProductService,
    CsvService,
    ConfirmationService
  ]
})
export class DadReportingModule {
}
